import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { WrapUpOutcomePolicy } from 'src/core/models/wrap-up-definition/wrap-up-outcome-policy.enum';

@Api('api/agentic-cx/wrap-up-definition')
export class WrapUpDefinitionDto extends DtoHasApi {
  id = 0;
  name = '';
  isActive = true;
  isPredefined = false;
  policy: WrapUpOutcomePolicy = WrapUpOutcomePolicy.Completed;
  queueIds: number[] = [];
  queues: { id: number; name: string }[] = [];
}
